
import DefaultLayout from './default.vue'

export default DefaultLayout.extend({
  name: 'UnauthenticatedLayout',
  middleware: ['browserSupport', 'preferredLocale'],
})
